export const PAGE_TYPE_HEADER_NAME = "x-page-type"
